<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Events'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Events'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    text: 'Page Type',
                    value: 'pageType',
                    fixedValue: 'Event',
                    width: '150px',
                    sortable: false,
                    filterable: false
                },
                {
                    value: 'status',
                    type: 'enum',
                    enumOptions: ['draft', 'published'],
                    width: '150px'
                },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'date',
                    type: 'date',
                    width: '150px',
                    filter: value => this.$dayjs(value).format('DD/MM/YYYY')
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Full URL',
                    value: 'fullUrl',
                    filter: 'getUrl',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'event',
                        incudeFullUrl: true
                    }
                },
                {
                    text: 'URL Path',
                    filter: 'getUrl',
                    value: 'urlPath',
                    width: '150px',
                    skipValue: true,
                    sortable: false,
                    filterable: false,
                    filterOptions: {
                        type: 'event'
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'events/index',
            deleteItem: 'events/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/events/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/events/add');
        }
    }
};
</script>
